import baseRoute from '../baseRoute';

export default `${baseRoute}/employee` as const;
